export default __webpack_public_path__ + "static/media/suva-blue_arrow.87290737.png";